<div class="h-10 bg-white flex items-center justify-between gap-3">
  @if (canCancel) {
    <rk-button
      btnStyle="orange"
      (click)="cancelled.emit()"
      [label]="cancelText || ('MODAL.DEFAULT.CANCEL' | translate)"
      [fullWidth]="true"
    ></rk-button>
  }
  <rk-button
    btnStyle="main"
    (click)="submitted.emit()"
    [label]="submitText || ('MODAL.DEFAULT.SAVE' | translate)"
    [disabled]="disabledSubmit"
    [fullWidth]="true"
  ></rk-button>
</div>
